import {Typography, useMediaQuery} from "@mui/material";
import {Children} from "../../types/WithChildren";
import * as React from "react";

type props = {
  children: Children,
  isSmol?: boolean
}

export default function SectionHeader({children, isSmol}: props) {
  // @ts-ignore
  const align = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <Typography variant="overline" fontSize={align || isSmol ? 14 : 24} paddingBottom={0}><b>{children}</b></Typography>
  )
}